import React from 'react';
import { motion } from 'framer-motion';
import { PhoneIcon, StarIcon } from './icons/Icons';
import { HOUSECALL_IMAGE_URL, PHONE_DISPLAY, HOUSECALL_WHATSAPP_HREF, HOUSECALL_VIDEO_URL } from '../data/site';
import { useLanguage } from '../data/i18n';
import { VideoPlayer } from './VideoPlayer';
export function HouseCall() {
  const {
    t
  } = useLanguage();
  return <section id="house-call" className="relative w-full border-y border-white/10 bg-black py-24 sm:py-32 overflow-hidden" data-id="element-94" data-mp="3hz8kit0qh48k">
      <div className="absolute inset-0" data-id="element-95" data-mp="3835br4bdm7cn">
        <img src={HOUSECALL_IMAGE_URL} alt="" aria-hidden="true" className="h-full w-full object-cover opacity-40" data-id="element-96" data-mp="381amjdt2nt2r" />
        <div className="absolute inset-0 bg-black/70" data-id="element-97" data-mp="2z2p5jn390m43" />
      </div>

      <div className="relative z-10 mx-auto max-w-4xl px-6 text-center" data-id="element-98" data-mp="2z4jurdljz0dz">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mx-auto flex items-center justify-center gap-2" data-id="element-99" data-mp="11bmlthxn9b7h">
          {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-7 h-7 text-[#D4AF37]" data-id="element-100" data-mp="3aw9vtjyljbpt" data-mpi={i} />)}
        </motion.div>

        <h2 className="mt-8 font-display text-5xl sm:text-7xl tracking-[0.05em] text-bone" data-id="element-101" data-mp="2x0o4v78syhur">{t.houseCall.title}</h2>
        <p className="mt-6 font-body text-lg font-light text-white/70" data-id="element-102" data-mp="3oprb2sk922a1">{t.houseCall.subtitle}</p>

        <ul className="mt-10 flex flex-wrap items-center justify-center gap-x-6 gap-y-3" data-id="element-103" data-mp="3touhagbyuejl">
          {t.houseCall.places.map(place => <li key={place} className="font-sans text-[11px] uppercase tracking-[0.3em] text-bone" data-id="element-104" data-mp="3fwed3c7bwah3">
              {place}
            </li>)}
        </ul>

        <p className="mt-10 font-display text-3xl tracking-[0.12em] text-bone" data-id="element-105" data-mp="bjhiawxu3b87">{t.houseCall.punch}</p>

        <a href={HOUSECALL_WHATSAPP_HREF} target="_blank" rel="noreferrer" className="mt-10 inline-flex items-center gap-3 bg-white px-9 py-4 font-sans text-[11px] uppercase tracking-[0.3em] text-black hover:bg-white/85 transition-colors" data-id="element-106" data-mp="g9pj8q9g1tjw">
          <PhoneIcon className="w-4 h-4" data-id="element-107" data-mp="h59lfwnsvqj4" />
          {PHONE_DISPLAY}
        </a>

        <div className="mt-20" data-id="element-108" data-mp="h7cmdbqhr42m">
          <p className="mb-8 font-display text-2xl sm:text-3xl tracking-[0.08em] text-bone" data-id="element-109" data-mp="c6ome0kabcw9">
            {t.houseCall.videoText}
          </p>
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.7
        }} className="mx-auto max-w-sm" data-id="element-110" data-mp="78n1rb77n5io">
            <VideoPlayer src={HOUSECALL_VIDEO_URL} className="aspect-[9/16]" data-id="element-111" data-mp="3pluo6vpu9nds" />
          </motion.div>
        </div>
      </div>
    </section>;
}